import { BatchProvider } from '../tools/batch';
import { PreSettings } from '../shared/setting-model';
import { calculAgencyComSaleExclVat, formatCy, formatNumberWithCommas, getWebURLs, land_m2, mergeResidenceUnitSynap } from './tools';
import { GlobalConstants } from './global-constants';

const cies: any = {
    mur: 'Rs',
    eur: '€',
    usd: '$',
    zar: 'R',
};

const preSettings = new PreSettings();
const GLOBAL = new GlobalConstants();

let prefixMandate = 'NES';
if (typeof process !== 'undefined' && process.env.GCLOUD_PROJECT === 'nestenn-ll') {
    prefixMandate = 'LL';
} else if (typeof window !== 'undefined' && window.location.hostname.includes('nestenn-ll')) {
    prefixMandate = 'LL';
}

export default function updateList(batch: BatchProvider, data: any, params: any): any {
    const modulePath = `list/modules/${params.module}/${params.key}`;
    const mandatesMatchingPath = `mandatesMatching/${params.key}`;
    const projectsMatchingPath = `projectsMatching/${params.key}`;

    let listObj: any = null;

    if (data) {
        // if (newItem) {
        //     batch.set(modulePath, getModuleData(params.module, data));
        // } else {
        listObj = getModuleListData(params.module, data);
        batch.set(modulePath, listObj);
        // }
        if (params.module === 'mandates') {
            handleMatchingMandate(batch, data, mandatesMatchingPath);
        }
    } else {
        batch.delete(modulePath);
        if (params.module === 'mandates') {
            batch.delete(mandatesMatchingPath);
        }
        if (params.module === 'projects') {
            batch.delete(projectsMatchingPath);
        }
    }

    return listObj;
}

export function getModuleListData(module: string, data: any) {
    switch (module) {
        case 'actions': return actions(data);
        case 'blogs': return blogs(data);
        case 'brokers': return brokers(data);
        case 'contacts': return contacts(data);
        case 'companies': return companies(data);
        case 'files': return files(data);
        case 'mandates': return mandates(data);
        case 'matchings': return matchings(data);
        case 'projects': return projects(data);
        case 'residences': return residences(data);
        case 'units': return units(data);
        default: return null;
    }
}

function handleMatchingMandate(batch: BatchProvider, data: any, matchingPath: string) {
    if (['active', 'offer', 'signAgree', 'signLease'].includes(data.status) && data.synaps && data.synaps.unitMandates && Object.keys(data.synaps.unitMandates).length) {
        batch.set(matchingPath, mandatesMatching(data));
    } else {
        batch.delete(matchingPath);
    }
}



export function createList(data: any, module: string) {

    switch (module) {
        case 'actions': {
            return actions(data)
        }
        case 'brokers': {
            return brokers(data);
        }
        case 'contacts': {
            return contacts(data);
        }
        case 'companies': {
            return companies(data);
        }
        case 'files': {
            return files(data);
        }
        case 'residences': {
            return residences(data);
        }
        case 'mandates': {
            return mandates(data);
        }
        case 'matchings': {
            return matchings(data);
        }
        case 'projects': {
            return projects(data);
        }
        case 'units': {
            return units(data);
        }
        default: {
            return null;
        }
    }
}


const icons: any = {
    house: 'home',
    apartment: 'apartment',
    office: 'work',
    commercial: 'shopping_cart',
    land: 'crop_free',
    building: 'location_city',
}


export function brokers(data: any): any {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        ref: data.ref ? data.ref : '????',
        displayname: null,
        icon: GLOBAL.ICONS.BROKER,
        iconColor: data.status ? data.status : null,
        status: data.status ? data.status : null,
        statusDisplay: data.status ? preSettings.getParamName('brokerStatus', data.status) : null,
        typeDisplay: null,
        fee: data.fee ? data.fee : 0,
        allAgencies: data.allAgencies ? data.allAgencies : false,
        agenciesDisplay: data.allAgencies ? ["all"] : (data.agencies ? data.agencies : []),
        agencies: data.agencies ? data.agencies : [],
        dateStart: data.dateStart ? data.dateStart : null,
        dateEnd: (data.dateEnd && data.status === 'inactive') ? data.dateEnd : null,
    }
    if (data.synaps?.contactBroker) {
        listObj.type = 'contact';
        listObj.typeDisplay = 'Contact';
        for (const contactKey in data.synaps.contactBroker) {
            if (data.synaps.contactBroker[contactKey] && data.synaps.contactBroker[contactKey].fullname) {
                listObj.displayname = data.synaps.contactBroker[contactKey].fullname;
                break;
            }
        }
    }
    if (data.synaps?.companyBroker) {
        listObj.type = 'company';
        listObj.typeDisplay = 'Company';
        for (const companyKey in data.synaps.companyBroker) {
            if (data.synaps.companyBroker[companyKey] && data.synaps.companyBroker[companyKey].displayname) {
                listObj.displayname = data.synaps.companyBroker[companyKey].displayname;
                break;
            }
        }
    }

    return listObj;
}



export function units(data: any): any {

    const residence: any = mergeResidenceUnitSynap(data);

    let nbErrors = 0;
    let nbAlerts = 0;
    if (data.alerts && data.alerts.length) {
        for (const alert of data.alerts) {
            if (alert.type === 'error') {
                nbErrors++;
            } else {
                nbAlerts++;
            }
        }
    }

    const listObj: any = {
        $key: _checkUndefined(data.$key),
        icon: data.type && icons[data.type] ? icons[data.type] : null,
        iconColor: '',
        ref: _checkUndefined(data.ref),
        alerts: nbAlerts,
        errors: nbErrors,
        vefa: !!data.vefa,
        pm: !!data.pm,
        vefaName: _checkUndefined(data.vefaName),
        vefaNb: _checkUndefined(data.vefaNb),
        vefaAv: _checkUndefined(data.vefaAv),
        vefaNbDisp: `${data.vefaAv !== null ? data.vefaAv : '?'}/${data.vefaNb !== null ? data.vefaNb : '?'}`,
        type: _checkUndefined(data.type),
        city: _getAddressCity(data.address),
        gps: _checkUndefined(data.address?.gps),
        unitNb: _checkUndefined(data.address?.unitNb),
        sectors: _checkUndefined(data.address?.sectors || []),
        sector: _checkUndefined(data.address?.sector),
        bedrooms: _checkUndefined(data.bedrooms),
        bathrooms: _checkUndefined(data.bathrooms),
        condition: _checkUndefined(data.condition),
        surface: null,
        includeAC: !!data.includeAC,
        photo: _getFirstPhoto(data.synaps?.filesUnits),
        mandateTypes: [],
        rentalPrice: 0,
        rentalCy: 'MUR',
        salePrice: 0,
        saleCy: 'MUR',
        rentalStatus: null,
        rentalStatusIcon: null,
        rentalRealtor: null,
        rentalAgency: null,
        followUp: null,
        foreigner: false,
        residence: null,
        scheme: null,
        mandates: [],
        owners: [],
    }


    // Surface
    if (data.type === 'land') { //TODO: separate land from interior surface
        listObj.surface = (data.landSurface && data.landUnit) ? land_m2(data.landSurface, data.landUnit) : null;
    } else {
        listObj.surface = data.builtSurface ? data.builtSurface : (data.livingSurface ? data.livingSurface : null);
    }


    if (residence) {
        listObj.residence = residence.name ? residence.name : null;
        listObj.scheme = residence.scheme ? residence.scheme : null;
    }

    if (data.synaps) {

        if (!data.vefa && data.synaps.owners) {
            for (const contactKey in data.synaps.owners) {
                if (data.synaps.owners[contactKey] && data.synaps.owners[contactKey].fullname) {
                    listObj.owners.push(data.synaps.owners[contactKey].fullname);
                }
            }
        }
        if (data.vefa && residence) {
            for (const residenceKey in data.synaps.residenceUnits) {
                if (data.synaps.residenceUnits[residenceKey] && data.synaps.residenceUnits[residenceKey].synaps && data.synaps.residenceUnits[residenceKey].synaps.promoter) {
                    for (const companyKey in data.synaps.residenceUnits[residenceKey].synaps.promoter) {
                        if (data.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey] && data.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey].displayname) {
                            listObj.owners.push(data.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey].displayname);
                        }
                    }
                }
            }
        }

        if (data.synaps.unitsActions) {
            let actionDone = null;
            let actionPending = null;
            for (const actionKey in data.synaps.unitsActions) {
                const action = data.synaps.unitsActions[actionKey];

                if (action.done && (!actionDone || action.date > actionDone)) {
                    actionDone = action.date;
                }
                if (!action.done && (!actionPending || action.date < actionPending)) {
                    actionPending = action.date;
                }
            }

            listObj.followUp = actionPending || actionDone || data.created;
        }

        if (data.synaps.unitMandates) {
            let latestRentalRef: number | null = null;
            let latestRentalStatus: string | null = null;
            let latestRentalRealtor: string | null = null;
            let latestRentalAgency: string | null = null;
            for (const mandateKey in data.synaps.unitMandates) {
                const mandate = data.synaps.unitMandates[mandateKey];
                const mandateRef = mandate.ref ? mandate.ref : 0;

                if (mandate.type === 'rental' && mandateRef && mandate.failedReason !== 'duplicate') {
                    if (!latestRentalRef || mandateRef > latestRentalRef) {
                        latestRentalRef = mandateRef;
                        latestRentalStatus = mandate.status || null;
                        latestRentalRealtor = mandate.realtor || null;
                        latestRentalAgency = mandate.agency || null;
                    }
                }

                if (mandate.status === 'active') {
                    listObj.mandateTypes.push(mandate.type);
                    listObj[mandate.type + 'Price'] = mandate.price;
                    listObj[mandate.type + 'Cy'] = mandate.cy;
                    listObj[mandate.type + 'Realtor'] = mandate.realtor;
                    if (mandate.type === 'sale') {
                        listObj.mandates.push(formatNumberWithCommas(listObj.salePrice) + ' ' + cies[listObj.saleCy]);

                        // if ((listObj.residence && listObj.scheme) || (listObj.type !== 'house')) {
                        //     listObj.foreigner = true;
                        // }
                    } else if (mandate.type === 'rental') {
                        listObj.rentalStatus = 'active';
                        listObj.rentalRealtor = mandate.realtor;
                        listObj.rentalAgency = mandate.agency;
                        listObj.rentalStatusIcon = preSettings.getParamIcon('mandateStatus', 'active');
                        listObj.mandates.push(formatNumberWithCommas(listObj.rentalPrice) + ' ' + cies[listObj.rentalCy]);
                    }
                    if (data.vefa) {
                        listObj.iconColor = 'vefa';
                    } else {
                        listObj.iconColor = 'active';
                    }
                }
            }

            if (!listObj.rentalStatus) {
                if (data.noRenting) {
                    listObj.rentalStatus = 'noRenting';
                    listObj.rentalStatusIcon = preSettings.getParamIcon('mandateStatus', 'noRenting');
                } else if (latestRentalStatus) {
                    listObj.rentalStatus = latestRentalStatus;
                    listObj.rentalStatusIcon = preSettings.getParamIcon('mandateStatus', latestRentalStatus);
                }
                if (latestRentalRealtor) {
                    listObj.rentalRealtor = latestRentalRealtor;
                }
                if (latestRentalAgency) {
                    listObj.rentalAgency = latestRentalAgency;
                }
            }
        }

    }

    return listObj;
}

export function _getFirstPhoto(filesObj: any): any {
    if (!filesObj || typeof filesObj !== 'object') return null;

    let firstPhoto = null;

    for (const key in filesObj) {
        const file = filesObj[key];
        if (file.type?.includes('image')) {
            if (!firstPhoto || (file.order !== undefined && file.order < firstPhoto.order)) {
                firstPhoto = file;
            }
        }
    }

    return firstPhoto;
}

export function residences(data: any): any {

    const schemes: any = {
        irs: 'IRS',
        res: 'RES',
        ihs: 'IHS',
        pds: 'PDS',
        senior: 'Senior Residence',
        smart: 'Smart City',
    };

    let nbErrors = 0;
    let nbAlerts = 0;
    if (data.alerts && data.alerts.length) {
        for (const alert of data.alerts) {
            if (alert.type === 'error') {
                nbErrors++;
            } else {
                nbAlerts++;
            }
        }
    }
    const listObj: any = {
        $key: data.$key ? data.$key : null,
        ad: !!data.ad,
        name: data.name ? data.name : null,
        icon: 'domain',
        iconColor: null,
        ref: data.ref ? data.ref : '????',
        alerts: nbAlerts,
        errors: nbErrors,
        types: data.types ? data.types : [],
        scheme: data.scheme ? data.scheme : null,
        schemeDisp: data.scheme ? schemes[data.scheme] : null,
        status: data.status ? data.status : null,
        statusDisp: data.status ? preSettings.getParamName('residenceStatus', data.status) : '',
        city: _getAddressCity(data.address),
        gps: data.address && data.address.gps ? data.address.gps : null,
        sector: data.address && data.address.sector ? data.address.sector : null,
        photo: _getFirstPhoto(data.synaps?.filesResidences),
        totalUnits: data.totalUnits ? data.totalUnits : 0,
        units: 0,
        nb: '',
        promoter: null,
        syndic: null,
        realtor: data.realtor ? data.realtor : null,
        agency: data.agency ? data.agency : null,
        // synaps: data.synaps ? data.synaps : {},
        // alias: alias,
        vefa: false,
        active: false,
        followUp: null,
    }


    if (data.synaps) {
        // UNIT
        if (data.synaps.residenceUnits) {
            for (const unitKey in data.synaps.residenceUnits) {

                const unit = data.synaps.residenceUnits[unitKey];

                if (!unit.vefa) {
                    listObj.units++;
                }

                // PUT THE RESIDENCE AS ACTIVE VEFA IF AT LEAST ONE UNIT IS ACTIVE VEFA
                if (unit?.synaps?.unitMandates) {
                    for (const mandateKey in unit.synaps.unitMandates) {
                        const mandate = unit.synaps.unitMandates[mandateKey];
                        if (mandate.status === 'active') {
                            listObj.active = true;
                            listObj.iconColor = unit.vefa ? 'vefa' : 'active';
                            if (unit.vefa) {
                                listObj.vefa = true;
                            }
                        }
                    }
                }
            }
            // listObj.units = Object.values(data.synaps.residenceUnits).filter((unit: any) => !unit.vefa).length;
            listObj.nb = listObj.units + '/' + (listObj.totalUnits ? listObj.totalUnits : '?');
        }
        if (data.synaps.syndic) {
            for (const companyKey in data.synaps.syndic) {
                if (data.synaps.syndic[companyKey].displayname) {
                    listObj.syndic = data.synaps.syndic[companyKey].displayname;
                }
            }
        }
        if (data.synaps.promoter) {
            for (const companyKey in data.synaps.promoter) {
                if (data.synaps.promoter[companyKey].displayname) {
                    listObj.promoter = data.synaps.promoter[companyKey].displayname;
                }
            }
        }
        // ACTIONS

        if (data.synaps.residencesActions) {
            let actionDone = null;
            let actionPending = null;
            for (const actionKey in data.synaps.residencesActions) {
                const action = data.synaps.residencesActions[actionKey];

                if (action.done && (!actionDone || action.date > actionDone)) {
                    actionDone = action.date;
                }
                if (!action.done && (!actionPending || action.date < actionPending)) {
                    actionPending = action.date;
                }
            }

            listObj.followUp = actionPending || actionDone || data.dateNeed || data.created;
        }
    }

    return listObj;
}

// function getMandateIcon(status: string): string {
//     if (status === 'active') {
//         return 'book';
//     }
//     if (status === 'failed') {
//         return 'cancel';
//     }
//     if (status === 'deal') {
//         return 'task_alt';
//     }
//     if (status === 'pending') {
//         return 'sync';
//     }
//     if (status === 'pause') {
//         return 'pause';
//     }
//     if (status === 'estimation') {
//         return 'monetization_on';
//     }
//     return 'book';
// }

export function getActionIcon(type: string): string {
    const actionList: any = preSettings.getParamValues('actionTypes');

    if (actionList[type]) {
        return actionList[type].icon;
    }
    return 'exit_to_app';
}


export function getActionRoles(type: string): string[] {
    const actionList: any = preSettings.getParamValues('actionTypes');

    if (actionList[type]?.info?.userRoles) {
        return actionList[type].info.userRoles;
    }
    return [];
}

// function priceDisplay(data: any): string {
//     let price = '';
//     if (data.priceCies && data.priceCies.mur) {
//         price += formatNumberWithCommas(data.priceCies.mur);

//         if (data.priceNegCies && data.priceNegCies.mur) {
//             price += ' (' + formatNumberWithCommas(data.priceNegCies.mur) + ')';
//         }
//         price += ' Rs';
//     }
//     return price;
// }


function priceDisplay(price: number, cy: string): string | null {
    if (price && cy) {
        return cyDisplay(cy) + ' ' + formatNumberWithCommas(price);
    }
    return null;
}

// function priceDisplayFurnitureBrut(data: any): string {
//     let price = '';
//     if (data.priceFurniture) {
//         price += formatNumberWithCommas(data.priceFurniture);
//         price += ' ' + cyDisplay(data.cy);
//     }
//     return price;
// }

function cyDisplay(cy: string): string {
    switch (cy) {
        case 'mur': {
            return 'Rs';
            break;
        }
        case 'eur': {
            return '€';
        }
        case 'usd': {
            return '$';
        }
        case 'zar': {
            return 'Rd';
        }
        default: {
            return '?';
        }
    }
}

export function mandates(data: any) {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        icon: preSettings.getParamIcon('mandateStatus', data.status),
        ref: data.ref ? data.ref : '????',
        dateAvailable: data.dateAvailable ? data.dateAvailable : null,
        followUp: null,
        price: (data.priceNegCies && data.priceNegCies.mur) ? data.priceNegCies.mur : ((data.priceCies && data.priceCies.mur) ? data.priceCies.mur : null),
        priceDisplay: priceDisplay(data.price, data.cy),
        priceNegDisplay: priceDisplay(data.priceNeg, data.cy),
        realtor: data.realtor ? data.realtor : null,
        referral: data.referral ? data.referral : null,
        referralAgency: data.referralAgency ? data.referralAgency : null,
        referralCom: data.referralCom ? data.referralCom : null,
        agency: data.agency ? data.agency : null,
        status: data.status ? data.status : null,
        temperature: data.temperature ? data.temperature : null,
        type: data.type ? data.type : null,
        owners: [],
        matchings: 0,
        newMatchings: 0,
        matchingsDisplay: '',
    }
    listObj.iconColor = data.status === 'active' ? (listObj.temperature ? listObj.temperature : null) : listObj.status;

    if (data.synaps) {
        // UNIT
        if (data.synaps.unitMandates) {
            for (const unitKey in data.synaps.unitMandates) {
                const unit = data.synaps.unitMandates[unitKey];
                getUnitData(listObj, unit);
            }
        }
        if (listObj.condition === 'vefa') {
            listObj.iconColor = 'vefa';
        }

        // MATCHING
        if (data.synaps.mandateMatchings) {
            for (const matchingKey in data.synaps.mandateMatchings) {
                if (data.synaps.mandateMatchings[matchingKey]) {
                    if (data.synaps.mandateMatchings[matchingKey].active) {
                        listObj.matchings++;
                    }
                    if (data.synaps.mandateMatchings[matchingKey].new) {
                        listObj.newMatchings++;
                    }
                }
            }
            listObj.matchingsDisplay = listObj.newMatchings ? (listObj.newMatchings + ' New!') : (listObj.matchings + '');
        }
        // ACTIONS
        if (data.synaps.mandatesActions) {
            let actionDone = null;
            let actionPending = null;
            for (const actionKey in data.synaps.mandatesActions) {
                const action = data.synaps.mandatesActions[actionKey];

                if (action.type !== 'marketingCheck') {
                    if (action.done && (!actionDone || action.date > actionDone)) {
                        actionDone = action.date;
                    }
                    if (!action.done && (!actionPending || action.date < actionPending)) {
                        actionPending = action.date;
                    }
                }
            }

            listObj.followUp = actionPending || actionDone || data.dateAvailable || data.created;
        }
    }


    return listObj;
}

export function projects(data: any): any {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        status: data.status,
        icon: preSettings.getParamIcon('projectStatus', data.status),
        iconColor: data.status ? (data.status === 'active' ? (data.temperature ? data.temperature : null) : data.status) : '',
        ref: data.ref ? data.ref : '????',
        created: data.created ? data.created : null,
        dateNeed: data.dateNeed ? data.dateNeed : null,
        followUp: null,
        dateEnd: null,
        duration: null,
        maxBudget: data.maxBudget ? data.maxBudget : null,
        minBudget: data.minBudget ? data.minBudget : (data.maxBudget ? Math.round(data.maxBudget / 2) : null),
        budget: budgetDisplay(data),
        realtor: data.realtor ? data.realtor : null,
        agency: data.agency ? data.agency : null,
        referral: data.referral ? data.referral : null,
        referralAgency: data.referralAgency ? data.referralAgency : null,
        referralCom: data.referralCom ? data.referralCom : null,
        temperature: data.temperature ? data.temperature : null,
        type: data.type ? data.type : null,
        minBedrooms: data.minBedrooms ? data.minBedrooms : null,
        minBathrooms: data.minBathrooms ? data.minBathrooms : null,
        unitTypeIcons: getUnitTypesIcons(data.unitTypes),
        unitTypes: data.unitTypes ? data.unitTypes : [],
        conditions: data.conditions ? data.conditions : [],
        contactsProjects: [],
        matchings: 0,
        newMatchings: 0,
        matchingsDisplay: '',
        // synaps: data.synaps ? data.synaps : {},
        // alias: alias,
    }
    // console.log('test1');
    if (data.synaps) {
        // CONTACTS
        if (data.synaps.contactsProjects) {
            for (const contactKey in data.synaps.contactsProjects) {
                if (data.synaps.contactsProjects[contactKey] && data.synaps.contactsProjects[contactKey].fullname) {
                    listObj.contactsProjects.push(data.synaps.contactsProjects[contactKey].fullname);
                }
            }
        }


        // ACTIONS
        if (data.synaps.projectsActions) {
            let actionDone = null;
            let actionPending = null;
            for (const actionKey in data.synaps.projectsActions) {
                const action = data.synaps.projectsActions[actionKey];

                if (action.done && (!actionDone || action.date > actionDone)) {
                    actionDone = action.date;
                }
                if (!action.done && (!actionPending || action.date < actionPending)) {
                    actionPending = action.date;
                }
            }

            listObj.followUp = actionPending || actionDone || data.dateNeed || data.created;
        }

        // MATCHING
        if (data.synaps.projectMatchings) {
            for (const matchingKey in data.synaps.projectMatchings) {
                if (data.synaps.projectMatchings[matchingKey]) {
                    if (data.synaps.projectMatchings[matchingKey].active) {
                        listObj.matchings++;
                    }
                    if (data.synaps.projectMatchings[matchingKey].new) {
                        listObj.newMatchings++;
                    }
                }
            }
            listObj.matchingsDisplay = listObj.newMatchings ? (listObj.newMatchings + ' New!') : (listObj.matchings + '')
        }

    }


    return listObj;

}


function budgetDisplay(data: any): string {
    let budget = '';
    if (data.maxBudget) {
        if (data.minBudget) {
            budget += formatNumberWithCommas(data.minBudget);
        } else {
            budget += '-';
        }
        budget += ' < '
        budget += formatNumberWithCommas(data.maxBudget);
        budget += ' ' + formatCy(data.cy);
    }
    return budget;
}

function getUnitTypesIcons(unitTypes: string[]): string[] {
    const unitTypeIcons: string[] = [];

    if (unitTypes) {
        for (const type of unitTypes) {
            if (icons[type]) {
                unitTypeIcons.push(icons[type]);
            }
        }
    }

    return unitTypeIcons;
}

function getSectors(sectors: []): string {
    let value = '';

    if (sectors && sectors.length) {
        let i = 0;
        for (const sector of sectors) {
            for (const sectorSetting of preSettings.regions.sectors) {
                if (sector === sectorSetting.name) {
                    value += (i > 0 ? ', ' : '') + sectorSetting.title;
                    i++;
                }
            }
        }
    }

    return value;
}

// function getParamNames(paramType: string, list: string[]): string {
//     let value = '';

//     if (paramType && list && list.length) {
//         const params: any = preSettings.getParamValues(paramType);
//         if (params) {
//             let i = 0;
//             for (const param of list) {
//                 if (params[param]) {
//                     value += (i > 0 ? ', ' : '') + params[param].name;
//                 }
//                 i++;
//             }
//         }
//     }

//     return value;
// }



export function blogs(data: any): any {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        ref: data.ref ? data.ref : '????',
        date: data.date ? data.date : null,
        created: data.created ? data.created : null,
        icon: GLOBAL.ICONS.BLOG,
        iconColor: data.online ? 'online' : '',
        topcis: data.topics ? data.topics : [],
        title: (data.title && data.title.en) ? data.title.en : '',
    }

    return listObj;
}


export function contacts(data: any): any {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        icon: 'person',
        iconColor: (!data.notDuplicate && data.duplicateKey) ? 'hot' : '',
        ref: data.ref ? data.ref : '????',
        title: data.title ? data.title : '',
        firstname: data.firstname ? data.firstname : '',
        lastname: data.lastname ? data.lastname : '',
        fullname: data.fullname ? data.fullname : _buildFullname(data),
        lang: data.lang ? data.lang : null,
        nationalities: data.nationalities ? data.nationalities : [],
        emails: data.emails ? data.emails : [],
        tels: data.tels ? data.tels : [],
        country: data.country ? data.country : null,
        birthday: data.birthday ? data.birthday : null,
        units: 0,
        projects: 0,
        owner: false,
        renter: false,
        buyer: false,
        renterActive: false,
        buyerActive: false,
        client: false,
        agencies: {},
        realtors: {},
        brokerStatus: null,
        duplicate: (!data.notDuplicate && data.duplicateKey) ? data.duplicateKey : null,
    }

    if (data.synaps) {
        if (data.synaps.owners) {
            listObj.units = Object.keys(data.synaps.owners).length;
            if (listObj.units) {
                listObj.owner = true;
                for (const unitKey in data.synaps.owners) {
                    const unit = data.synaps.owners[unitKey];
                    if (unit.synaps?.unitMandates) {
                        for (const unitMandateKey in unit.synaps.unitMandates) {
                            const mandate = unit.synaps.unitMandates[unitMandateKey];
                            if (mandate.realtor) {
                                listObj.realtors[mandate.realtor] = true;
                            }
                            if (mandate.agency) {
                                listObj.agencies[mandate.agency] = true;
                            }
                        }
                    }
                }
            }
        }
        if (data.synaps.contactsProjects) {
            for (const projectKey in data.synaps.contactsProjects) {
                const project = data.synaps.contactsProjects[projectKey];

                listObj.projects++;
                if (project.status === 'deal') {
                    listObj.client = true;
                }
                if (project.type === 'sale') {
                    listObj.buyer = true;
                    if (project.status === 'active') {
                        listObj.buyerActive = true;
                    }
                } else if (project.type === 'rental') {
                    listObj.renter = true;
                    if (project.status === 'active') {
                        listObj.renterActive = true;
                    }
                }
                if (project.agency) {
                    listObj.agencies[project.agency] = true;
                }
                if (project.realtor) {
                    listObj.realtors[project.realtor] = true;
                }
            }
        }
        if (data.synaps.brokerContact) {
            for (const brokerKey in data.synaps.brokerContact) {
                const broker = data.synaps.brokerContact[brokerKey];
                if (broker) {
                    listObj.brokerStatus = broker.status || null;
                }
            }
        }

    }

    return listObj;
}

function _buildFullname(data: any): string {

    const titles: { [id: string]: string } = {
        'MR': 'Mr',
        'MRS': 'Mrs',
        'MISS': 'Ms',
    };

    let fullname = '';
    if (data) {
        if (data.title) {
            fullname += titles[data.title] + ' ';
        }
        if (data.firstname) {
            fullname += data.firstname;
        }
        if (data.firstname && data.lastname) {
            fullname += ' ';
        }
        if (data.lastname) {
            fullname += data.lastname;
        }
        if (data.nickname) {
            fullname += ' (' + data.nickname + ')';
        }
    }
    return fullname;
}

export function companies(data: any): any {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        icon: 'work',
        iconColor: '',
        ref: data.ref ? data.ref : '????',
        displayname: data.displayname ? data.displayname : '????',
        services: data.services ? data.services : [],
        employees: [],
        // synaps: data.synaps ? data.synaps : {},
        // alias: alias,
    }


    if (data.synaps) {
        if (data.synaps.employees) {
            for (const contactKey in data.synaps.employees) {
                if (data.synaps.employees[contactKey].fullname) {
                    listObj.employees.push(data.synaps.employees[contactKey].fullname);
                }
            }
        }


    }

    return listObj;
}

export function actions(data: any) {
    const listObj: any = {
        $key: data.$key || null,
        realtor: data.realtor || null,
        agency: data.agency || null,
        roles: getActionRoles(data.type),
        icon: getActionIcon(data.type),
        iconColor: _actionIconColor(data),
        done: !!data.done,
        type: data.type || null,
        medium: data.medium || null,
        date: data.date || null,
        doneDate: data.doneDate || null,
        note: data.note || null,
        module: data.module || null,
        mandate: {},
        matchings: [],
        project: {},
        residence: {},
        unit: {},
        fullnames: [],
        realtors: [],
        agencies: [],
    };

    if (data.realtor) {
        listObj.realtors.push(data.realtor);
    }
    if (data.agency) {
        listObj.agencies.push(data.agency);
    }

    const d = data.data;

    switch (data.type) {
        case 'newRequest':
            if (d) {
                listObj.note = d.msg || null;
                listObj.origin = d.origin || null;
                listObj.originName = d.originName || null;
                listObj.originType = d.originType || null;
                listObj.originName = _getProjectOrigin(d.originType, d.origin, d.originName);
                listObj.medium = d.medium || null;
                listObj.notAssigned = !(data.synaps && data.synaps.projectsActions);
                listObj.fullnames.push(d.fullname ? d.fullname : _buildFullname(d));
                listObj.referral = d.referral || null;
                listObj.module = 'projects';
                if (d.origin === 'lpsd') {
                    listObj.mediumTerm = d.mediumTerm || null;
                    listObj.inMauritius = !!d.inMauritius;
                    listObj.unitTypes = d.unitTypes || [];
                    listObj.penthouse = !!d.penthouse;
                    listObj.townhouse = !!d.townhouse;
                    listObj.landType = d.landType || null;
                    listObj.landSurface = d.landSurface || null;
                    listObj.landUnit = d.landUnit || null;
                    listObj.bedrooms = d.bedrooms || null;
                    listObj.bathrooms = d.bathrooms || null;
                    listObj.InteriorSurface = d.InteriorSurface || null;
                    listObj.regions = d.regions || null;
                    listObj.pricepriceCy = d.pricepriceCy || null;
                    listObj.furnished = !!d.furnished;
                    listObj.needRefurbishment = !!d.needRefurbishment;
                    listObj.firstBuyer = !!d.firstBuyer;
                }
            }
            break;
        case 'discovery':
            if (d) {
                listObj.dateNeed = d.dateNeed || null;
                listObj.temperature = d.temperature || null;
                listObj.foreigner = !!d.foreigner;
                listObj.residentPermit = !!d.residentPermit;
                listObj.sectors = getSectors(d.sectors);
                listObj.unitTypeIcons = getUnitTypesIcons(d.unitTypes);
                listObj.minBedrooms = d.minBedrooms || null;
                listObj.maxBudget = priceDisplay(d.maxBudget, d.cyBudget);
                listObj.module = 'projects';
            }
            break;
        case 'offer':
        case 'signAgree':
        case 'signDeed':
        case 'signLease':
            if (d) {
                listObj.accepted = !!d.accepted;
                listObj.canceled = !!d.canceled;
                listObj.note = d.note || null;
                listObj.module = 'projects';
                listObj.xrate = d.xrate || null;
                listObj.cy = d.cy || null;
            }
            break;
        case 'r1':
            if (d) {
                listObj.temperature = d.temperature || null;
                listObj.note = d.note || null;
                listObj.module = 'mandates';
            }
            break;
        case 'r2':
            if (d) {
                listObj.temperature = d.temperature || null;
                listObj.priceDisplay = priceDisplay(d.price, d.cy);
                listObj.note = d.note || null;
                listObj.module = 'mandates';
            }
            break;
        case 'signMandate':
            if (d) {
                listObj.temperature = d.temperature || null;
                listObj.priceDisplay = priceDisplay(d.price, d.cy);
                listObj.priceNegDisplay = priceDisplay(d.priceNeg, d.cy);
                listObj.exclusive = !!d.exclusive;
                listObj.duration = d.duration || null;
                listObj.dateAvailable = d.dateAvailable || null;
                listObj.incl = d.incl || null;
                listObj.note = d.note || null;
                listObj.module = 'mandates';
                listObj.xrate = d.xrate || null;
            }
            break;
        case 'visitReport':
            if (d) {
                listObj.com = !!d.com;
                listObj.medium = d.medium || null;
                listObj.send = !!d.send;
                listObj.sent = !!d.sent;
                listObj.note = d.note || null;
                listObj.module = 'mandates';
            }
            break;
        case 'price':
            if (d) {
                listObj.price = priceDisplay(d.price, d.cy);
                listObj.priceNeg = d.priceNeg ? priceDisplay(d.priceNeg, d.cy) : null;
                listObj.note = d.note || null;
                listObj.module = 'mandates';
            }
            break;
        case 'payment':
            if (d) {
                listObj.amount = d.amount;
                listObj.amountDisplay = priceDisplay(d.amount, d.cy);
                listObj.ref = d.ref || null;
                listObj.paymentType = d.paymentType || null;
                listObj.paymentTypeText = d.paymentType ? preSettings.getParamName('paymentTypes', d.paymentType) : null;
                listObj.module = _getModule(data.synaps);
                listObj.due = d.due || data.date || null;
            }
            break;
        case 'advertise':
            if (d) {
                listObj.ad = !!d.ad;
                listObj.priceVisible = !!d.priceVisible;
                listObj.module = 'mandates';
            }
            break;
        case 'marketingCheck':
            if (d) {
                listObj.module = 'marketing';
            }
            break;
        case 'marketingAlert':
            if (d) {
                listObj.module = 'marketing';
                listObj.portal = d.portal || null;
                listObj.portalRef = d.portalRef || null;
                listObj.errors = d.errors || [];
            }
            break;
        case 'newMandate':
            if (d) {
                listObj.origin = d.origin || null;
                listObj.originType = d.originType || null;
                listObj.originName = _getMandateOrigin(d.originType, d.origin, d.originName);
                listObj.referral = d.referral || null;
                listObj.note = d.msg || null;
                listObj.module = 'mandates';
            }
            break;
        case 'handover':
        case 'temperature':
            if (d) {
                listObj.from = d.from || null;
                listObj.to = d.to || null;
                listObj.module = _getModule(data.synaps);
            }
            break;
        case 'failed':
            if (d) {
                listObj.failedReason = d.failedReason || null;
                listObj.note = d.note || null;
                listObj.module = _getModule(data.synaps);
            }
            break;
        case 'visit':
            listObj.module = 'projects';
            break;
        case 'call':
        case 'NACall':
        case 'meeting':
        case 'email':
        case 'sms':
        case 'active':
        case 'accept':
        case 'pause':
            listObj.module = _getModule(data.synaps);
            break;
    }

    if (data.synaps) {
        if (data.type === 'visit' && data.synaps.visit) {
            for (const matchingKey in data.synaps.visit) {
                listObj.matchings.push(matchingKey);
            }
            delete listObj.mandate;
        }

        if (['offer', 'signAgree', 'signDeed', 'signLease', 'visitReport'].includes(data.type)) {
            if (data.synaps[data.type]) {
                for (const matchingKey in data.synaps[data.type]) {
                    listObj.matching = matchingKey;
                }
            }
            if (d) {
                listObj.priceDisplay = priceDisplay(d.price, d.cy);
            }
        }


        if (data.synaps.projectsActions) {
            for (const projectKey in data.synaps.projectsActions) {
                const project = data.synaps.projectsActions[projectKey];
                listObj.project.$key = projectKey;
                _getProjectData(listObj, project);
                if (['offer', 'signAgree', 'signDeed', 'signLease', 'payment'].includes(data.type)) {
                    if (project.realtor && !listObj.realtors.includes(project.realtor)) {
                        listObj.realtors.push(project.realtor);
                    }
                    if (project.agency && !listObj.agencies.includes(project.agency)) {
                        listObj.agencies.push(project.agency);
                    }
                    listObj.projectCA = calculAgencyComSaleExclVat(data.data, data.projectFee, project.type);
                    listObj.projectCADisplay = priceDisplay(listObj.projectCA, data.data?.cy);
                }
            }
        }
        if (data.synaps.mandatesActions) {
            for (const mandateKey in data.synaps.mandatesActions) {
                if (['marketingCheck', 'newRequest', 'offer', 'signLease', 'signAgree', 'signDeed', 'signMandate', 'payment'].includes(data.type)) {
                    const mandate = data.synaps.mandatesActions[mandateKey];
                    listObj.mandate.$key = mandateKey;
                    _getMandateData(listObj, mandate);
                    listObj.budget = priceDisplay(mandate.price, mandate.cy);
                    if (['offer', 'signAgree', 'signDeed', 'signLease', 'payment'].includes(data.type)) {
                        if (mandate.realtor && !listObj.realtors.includes(mandate.realtor)) {
                            listObj.realtors.push(mandate.realtor);
                        }
                        if (mandate.agency && !listObj.agencies.includes(mandate.agency)) {
                            listObj.agencies.push(mandate.agency);
                        }
                        listObj.mandateCA = calculAgencyComSaleExclVat(data.data, data.mandateFee, mandate.type);
                        listObj.mandateCADisplay = priceDisplay(listObj.mandateCA, data.data?.cy);
                    }

                } else {
                    listObj.mandate.$key = mandateKey;
                }
            }
        }
        if (data.synaps.residencesActions) {
            for (const residenceKey in data.synaps.residencesActions) {
                listObj.residence.$key = residenceKey;
            }
        }
        if (data.synaps.unitsActions) {
            for (const unitKey in data.synaps.unitsActions) {
                listObj.unit.$key = unitKey;
            }
        }
        if (listObj.module === 'projects' && listObj.project.contactsProjects) {
            listObj.fullnames = listObj.project.contactsProjects;
            if (data.type === 'payment') {
                listObj.refDisplay = 'C' + listObj.project.ref;
                listObj.refRealtor = listObj.project.realtor;
            }
        } else if (listObj.module === 'mandates' && listObj.mandate.owners) {
            listObj.fullnames = listObj.mandate.owners;
            if (data.type === 'payment') {
                listObj.refDisplay = prefixMandate + listObj.mandate.ref;
                listObj.refRealtor = listObj.mandate.realtor;
            }
        }
    }

    return listObj;
}

function _getModule(synaps: any): string | null {
    if (synaps) {
        if (synaps.projectsActions) {
            return 'projects';
        }
        if (synaps.mandatesActions) {
            return 'mandates';
        }
        if (synaps.unitsActions) {
            return 'units';
        }
    }
    return null;
}

function _actionIconColor(data: any): string {
    if (data.type === 'newRequest' || data.type === 'visit' || data.type === 'marketingAlert') {
        return 'hot';
    }
    if (data.type === 'discovery') {
        return 'warm';
    }
    if (data.type === 'takeNews') {
        return 'cold';
    }
    return 'warm';
}



export function _getProjectOrigin(originType: string, origin: string, originName: string): string {
    if (originType) {
        let originTypeName = preSettings.getParamName("projectOriginTypes", originType);

        if (originName) {
            originTypeName += (': ' + originName);
        } else {

            const originTypes = preSettings.getParamValues("projectOriginTypes");

            if (origin && originTypes && originTypes[originType]?.info?.param) {
                //Check if Param in DB
                const paramKey = originTypes[originType].info.param;
                originTypeName += (': ' + preSettings.getParamName(paramKey, origin));
            }
        }
        return originTypeName;
    }
    return 'Unknown';
}

function _getMandateOrigin(originType: string, origin: string, originName: string): string {
    if (originType) {
        let originTypeName = preSettings.getParamName("mandateOriginTypes", originType);

        if (originName) {
            originTypeName += (': ' + originName);
        } else {

            const originTypes = preSettings.getParamValues("mandateOriginTypes");

            if (origin && originTypes && originTypes[originType]?.info?.param) {
                originTypeName += (': ' + preSettings.getParamName(originTypes[originType]?.info?.param, origin));
            }
        }
        return originTypeName;
    }
    return 'Unknown';
}


export function files(data: any) {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        created: data.created ? data.created : null,

        icon: data.type ? preSettings.getParamIcon('fileTypes', data.type) : null,
        name: data.name ? data.name : null,
        type: data.type ? data.type : null,
        url: data.url ? data.url : null,
        order: data.order ? data.order : null,

        info: data.info ? data.info : {},

        units: [],
        residences: [],
    }

    if (data.synaps) {
        // UNITS
        if (data.synaps.filesUnits) {
            for (const unitKey in data.synaps.filesUnits) {
                listObj.units.push(unitKey);
            }
        }
        //RESIDENCES
        if (data.synaps.filesResidences) {
            for (const residenceKey in data.synaps.filesResidences) {
                listObj.residences.push(residenceKey);
            }
        }
    }

    return listObj;
}



export function matchings(data: any) {

    const listObj: any = {
        $key: data.$key ? data.$key : null,
        created: data.created ? data.created : null,
        active: true,
        new: !!data.new,
        match: !!data.match,
        // com: !!data.com,
        visits: [],
        offer: false,
        signAgree: false,
        signDeed: false,
        signLease: false,
        // report: !!data.report,
        rate: data.rate ? data.rate : null,
        pos: _ObjectToArrayOrder(data.pos),
        neg: _ObjectToArrayOrder(data.neg),
        // note: data.note ? data.note : null,

        icon: data.new ? GLOBAL.ICONS.NEW : GLOBAL.ICONS.MATCHING,
        iconColor: 'cold',
        realtor: null,
        agency: null,
        score: 0,

        mandate: { owners: [] },
        project: {},
        // synaps: data.synaps ? data.synaps : {},
        // alias: alias,
    }

    if (data.synaps) {
        // MANDATE
        if (data.synaps.mandateMatchings) {
            for (const mandateKey in data.synaps.mandateMatchings) {
                const mandate = data.synaps.mandateMatchings[mandateKey];
                listObj.mandate.$key = mandateKey;
                _getMandateData(listObj, mandate);
                listObj.mandate.webURLs = getWebURLs(mandate);
            }
        }

        // PROJECT
        if (data.synaps.projectMatchings) {
            for (const projectKey in data.synaps.projectMatchings) {
                const project = data.synaps.projectMatchings[projectKey];
                listObj.project.$key = projectKey;
                _getProjectData(listObj, project);
                listObj.realtor = listObj.project.realtor ? listObj.project.realtor : null;
                listObj.agency = listObj.project.agency ? listObj.project.agency : null;
            }
        }

        // calcul score
        if (listObj.project.temperature && listObj.mandate.temperature) {
            listObj.score = _score(listObj.project.temperature) * _score(listObj.mandate.temperature);
            listObj.iconColor = matchingTemperature(listObj.score);
        }

        // VISITS
        if (data.synaps.visit) {
            for (const actionKey in data.synaps.visit) {
                listObj.visits.push(actionKey);
            }
        }
        // OFFER
        if (data.synaps.offer) {
            for (const actionKey in data.synaps.offer) {
                if (data.synaps.offer[actionKey]) {
                    listObj.offer = true;
                }
            }
        }
        // SIGN PURCHASE AGREEMEENT
        if (data.synaps.signAgree) {
            for (const actionKey in data.synaps.signAgree) {
                if (data.synaps.signAgree[actionKey]) {
                    listObj.signAgree = true;
                }
            }
        }
        // SIGN DEED
        if (data.synaps.signDeed) {
            for (const actionKey in data.synaps.signDeed) {
                if (data.synaps.signDeed[actionKey]) {
                    listObj.signDeed = true;
                }
            }
        }
        // SIGN LEASE
        if (data.synaps.signLease) {
            for (const actionKey in data.synaps.signLease) {
                if (data.synaps.signLease[actionKey]) {
                    listObj.signLease = true;
                }
            }
        }
        listObj.active = _matchingActive(listObj);
    }

    // console.log(JSON.stringify(listObj));

    return listObj;
}

export function matchingTemperature(score: number): string {
    if (score) {
        if (score < 4) {
            return 'cold';
        } else if (score < 9) {
            return 'warm';
        } else {
            return 'hot';
        }
    }
    return 'cold';
}

function _matchingActive(listObj: any): boolean {
    return (listObj.match || listObj.new) && listObj.mandate?.status === 'active' && listObj.project?.status === 'active';
}

function _score(temperature: string): number {
    if (temperature === 'hot')
        return 3;
    if (temperature === 'warm')
        return 2;
    if (temperature === 'cold')
        return 1;
    return 0;
}

function _ObjectToArrayOrder(obj: { [key: string]: { txt: string, order: number } }): string[] {
    const array: string[] = [];

    if (obj) {
        const arrayTemp: { txt: string, order: number }[] = [];

        for (const key in obj) {
            arrayTemp.push(obj[key]);
        }
        for (const v of arrayTemp.sort((a: any, b: any) => { return a.order - b.order })) {
            if (v.txt) {
                array.push(v.txt);
            }
        }

    }
    return array;
}


function _getProjectData(listObj: any, project: any) {
    listObj.project.ref = project.ref ? project.ref : '????';
    listObj.project.dateNeed = project.dateNeed ? project.dateNeed : null;
    listObj.project.minBedrooms = project.minBedrooms ? project.minBedrooms : null;
    listObj.project.budget = budgetDisplay(project);
    listObj.project.realtor = project.realtor ? project.realtor : null;
    listObj.project.agency = project.agency ? project.agency : null;
    listObj.project.status = project.status ? project.status : null;
    listObj.project.temperature = project.temperature ? project.temperature : null;
    listObj.project.type = project.type ? project.type : null;
    listObj.project.icon = preSettings.getParamIcon('projectStatus', project.status);
    listObj.project.iconColor = project.status === 'active' ? listObj.project.temperature : listObj.project.status;
    listObj.project.unitTypeIcons = getUnitTypesIcons(project.unitTypes);
    listObj.project.contactsProjects = [];

    if (project.synaps && project.synaps.contactsProjects) {
        for (const contactKey in project.synaps.contactsProjects) {
            if (project.synaps.contactsProjects[contactKey].fullname) {
                listObj.project.contactsProjects.push(project.synaps.contactsProjects[contactKey].fullname);
            }
        }
    }
}

function _getMandateData(listObj: any, mandate: any) {
    listObj.mandate.ref = mandate.ref ? mandate.ref : '????';
    listObj.mandate.dateAvailable = mandate.dateAvailable ? mandate.dateAvailable : null;
    // listObj.mandate.price = (mandate.priceNegCies && mandate.priceNegCies.mur) ? mandate.priceNegCies.mur : (mandate.priceCies ? mandate.priceCies.mur : null);
    listObj.mandate.priceDisplay = priceDisplay(mandate.price, mandate.cy);
    listObj.mandate.priceNegDisplay = priceDisplay(mandate.priceNeg, mandate.cy);
    listObj.mandate.realtor = mandate.realtor ? mandate.realtor : null;
    listObj.mandate.agency = mandate.agency ? mandate.agency : null;
    listObj.mandate.status = mandate.status ? mandate.status : null;
    listObj.mandate.temperature = mandate.temperature ? mandate.temperature : null;
    listObj.mandate.type = mandate.type ? mandate.type : null;
    listObj.mandate.icon = preSettings.getParamIcon('mandateStatus', mandate.status)
    listObj.mandate.iconColor = mandate.status === 'active' ? listObj.mandate.temperature : listObj.mandate.status;
    listObj.mandate.owners = [];

    if (mandate.synaps && mandate.synaps.unitMandates) {
        for (const unitKey in mandate.synaps.unitMandates) {
            const unit = mandate.synaps.unitMandates[unitKey];
            getUnitData(listObj.mandate, unit);
        }
    }
}


function getUnitData(listObj: any, unit: any) {
    listObj.unitType = unit.type ? unit.type : null;
    listObj.unitTypeIcon = unit.type ? (icons[unit.type] ? icons[unit.type] : null) : null;
    listObj.condition = unit.condition ? unit.condition : null;
    listObj.vefa = !!unit.vefa;
    listObj.pm = !!unit.pm;
    listObj.bedrooms = unit.bedrooms ? unit.bedrooms : null;
    listObj.bathrooms = unit.bathrooms ? unit.bathrooms : null;
    listObj.city = _getAddressCity(unit.address);
    // listObj.unitNb = unit.address && unit.address.unitNb ? unit.address.unitNb : null;
    listObj.residence = null;
    listObj.gps = unit.address && unit.address.gps ? unit.address.gps : null;
    listObj.photo = unit.photo ? unit.photo : null;
    listObj.score = listObj.status === 'active' ? (unit.score ? unit.score : 0) : null;

    // Surface
    if (unit.type === 'land') {
        listObj.surface = unit.landSurface ? unit.landSurface : null;
    } else {
        listObj.surface = unit.builtSurface ? unit.builtSurface : (unit.livingSurface ? unit.livingSurface : null);
    }

    // RESIDENCE
    if (unit.synaps?.residenceUnits) {
        for (const residenceKey in unit.synaps.residenceUnits) {
            if (unit.synaps.residenceUnits[residenceKey].name) {
                listObj.residence = unit.synaps.residenceUnits[residenceKey].name;
                if (unit.address && unit.address.unitNb) {
                    listObj.residence += ' - ' + unit.address.unitNb;
                }
            }
            if (unit.vefa) {
                if (unit.synaps.residenceUnits[residenceKey] && unit.synaps.residenceUnits[residenceKey].synaps && unit.synaps.residenceUnits[residenceKey].synaps.promoter) {
                    for (const companyKey in unit.synaps.residenceUnits[residenceKey].synaps.promoter) {
                        if (unit.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey] && unit.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey].fullname) {
                            listObj.owners.push(unit.synaps.residenceUnits[residenceKey].synaps.promoter[companyKey].fullname);
                        }
                    }
                }
            }
        }
    }

    // OWNERS
    if (!unit.vefa && unit.synaps && unit.synaps.owners) {
        for (const contactKey in unit.synaps.owners) {
            if (unit.synaps.owners[contactKey].fullname) {
                // console.log(listObj.owners);
                listObj.owners.push(unit.synaps.owners[contactKey].fullname);
            }
        }
    }
}




//****************  Return Mandate optimise for matching filters  ************/
export function mandatesMatching(mandate: any): any {

    const listObj: any = {
        $key: mandate.$key ? mandate.$key : null,
        // alias: alias ? alias : {},
        dateAvailable: _checkUndefined(mandate.dateAvailable),
        priceCies: (mandate.priceNeg && mandate.priceNegCies) ? mandate.priceNegCies : mandate.priceCies ? mandate.priceCies : null,
        status: _checkUndefined(mandate.status),
        type: _checkUndefined(mandate.type),
        temperature: _checkUndefined(mandate.temperature),
        ref: _checkUndefined(mandate.ref),
        realtor: _checkUndefined(mandate.realtor),
        agency: _checkUndefined(mandate.agency),
        exclusive: _checkUndefined(mandate.exclusive),
        price: _checkUndefined(mandate.price),
        priceNeg: _checkUndefined(mandate.priceNeg),
        cy: _checkUndefined(mandate.cy),
        synaps: {
            unitMandates: mandate.synaps.unitMandates,
        }
    }

    for (const unitKey in mandate.synaps.unitMandates) {
        const unit = mandate.synaps.unitMandates[unitKey];

        const residence = mergeResidenceUnitSynap(unit);

        if (residence) {
            listObj.residence = true;
            listObj.scheme = residence.scheme ? residence.scheme : null;
            listObj.morc = !!residence.morc;
            listObj.totalUnits = residence.totalUnits ? residence.totalUnits : null;
        } else {
            listObj.residence = false;
        }

        listObj.unitType = unit.type ? unit.type : null;
        listObj.landType = unit.landType ? unit.landType : null;
        listObj.leasehold = unit.leasehold ? unit.leasehold : null;

        listObj.penthouse = !!unit.penthouse;
        listObj.garden = !!unit.garden;
        listObj.condition = unit.condition ? unit.condition : null;
        listObj.style = unit.style ? unit.style : null;
        listObj.landSurface = (unit.landSurface && unit.landUnit) ? unit.landSurface : null;
        listObj.landUnit = unit.landUnit ? unit.landUnit : null;
        listObj.landSurfaceM2 = land_m2(listObj.landSurface, listObj.landUnit);

        listObj.bedrooms = unit.bedrooms ? unit.bedrooms : null;
        listObj.bathrooms = unit.bathrooms ? unit.bathrooms : null;
        listObj.city = _getAddressCity(unit.address);
        listObj.gps = unit.address && unit.address.gps ? unit.address.gps : null;
        listObj.sectors = unit.address && unit.address.sectors ? unit.address.sectors : [];

        listObj.includeAC = !!unit.includeAC;
        listObj.floor = unit.floor ? unit.floor : null;
        listObj.topFloor = unit.topFloor ? Number(unit.topFloor.substring(1)) : null;
        listObj.storeys = unit.storeys ? unit.storeys : null;
        listObj.kitchenType = unit.kitchenType ? unit.kitchenType : null;

        if (unit.params) {
            listObj.commonPool = !!unit.params.commonPool;
            listObj.privatePool = !!unit.params.privatePool;
            listObj.office = !!unit.params.office;
        }

        if (unit.equipment) {
            listObj.furnished = !!unit.equipment.furnished;
            listObj.semifurnished = !!unit.equipment.semifurnished;
            listObj.unfurnished = !!unit.equipment.unfurnished;
            listObj.petAllowed = !!unit.equipment.petAllowed;
            listObj.generator = !!unit.equipment.generator;
        }

        if (unit.appliances) {
            listObj.opticalFiber = !!unit.appliances.opticalFiber;
            listObj.wifi = !!unit.appliances.wifi;
        }

        if (unit.security) {
            listObj.alarm = !!unit.security.alarm;
            listObj.securityGuard = !!(unit.security.securityGuard || unit.security.watchman);
        }

        if (unit.view) {
            listObj.seaView = !!unit.view.seaView;
        }

        if (unit.area) {
            listObj.beachfront = !!unit.area.beachfront;
            listObj.seaAccess = !!unit.area.seaAccess;
            listObj.nearSchool = !!unit.area.nearSchool;
        }

    }

    return listObj;
}




function _checkUndefined(value: any): any {
    return value ? value : null;
}

function _getAddressCity(address: any): string | null {
    if (!address) {
        return null;
    }

    const countryCode = address.country ? (address.country + '').toUpperCase() : '';
    const isMauritius = !countryCode || countryCode === 'MU';
    const city = address.eCityName ? address.eCityName : (address.city ? address.city : null);

    if (!city) {
        return null;
    }

    if (isMauritius) {
        return city;
    }

    const countryName = preSettings.getParamName('countries', countryCode.toLowerCase())
        || preSettings.getParamName('countries', countryCode)
        || countryCode;

    return `${city} (${countryName})`;
}